import { useFormContext } from "react-hook-form";
import {
  businessDetails,
  PHONE_NO_COUNTRY_CODE,
} from "../../constants/variable";
import InputWithLabel from "../InputWithLabel";
import CustomDropdown from "./CustomDropdown";
import { FullRegistrationFormType } from "../../schemas/FullRegistrationFormSchema";
import { today } from "../../utils";
import Dropdown from "../DropDown";
import { companyPositionOptions } from "../../constants/xFlow";

export default function ApplicantDetailsFields() {
  const {
    register,
    formState: { errors },
  } = useFormContext<FullRegistrationFormType>();

  return (
    <div className="space-y-2">
      <div className="flex gap-4">
        <InputWithLabel
          label={"First Name"}
          placeholder="Enter here"
          {...register("first_name")}
          error={errors.first_name?.message}
          disabled
        />
        <InputWithLabel
          label={"Last Name"}
          placeholder="Enter here"
          {...register("last_name")}
          error={errors.last_name?.message}
          disabled
        />
      </div>

      <div className="flex gap-4">
        <CustomDropdown
          label="Nationality"
          placeholder="Please select nationality"
          name={`user_nationality`}
          category={businessDetails.COUNTRY_NAME}
          error={errors.user_nationality?.message}
        />
        <InputWithLabel
          label="Date Of Birth"
          type="date"
          {...register("user_dateOfBirth")}
          error={errors.user_dateOfBirth?.message}
          max={today}
        />
      </div>

      <div className="flex gap-4">
        <Dropdown
          label="Professional Position"
          placeholder="Please select position"
          options={companyPositionOptions}
          {...register("job_title")}
          error={errors.job_title?.message}
        />

        <InputWithLabel
          label={"Work Email"}
          placeholder="Enter here"
          {...register("work_email")}
          error={errors.work_email?.message}
          disabled
        />
      </div>

      <div className="flex gap-4">
        <Dropdown
          label="Country Code"
          placeholder="Select a country code"
          options={PHONE_NO_COUNTRY_CODE.map((el) => ({
            label: el.label,
            value: el.countryCode,
          }))}
          {...register("countryCode")}
          error={errors.countryCode?.message}
        />

        <InputWithLabel
          label={"Business Phone"}
          placeholder="Enter here"
          {...register("company_phone_number")}
          error={errors.company_phone_number?.message}
        />
      </div>

      {/* <ApplicantDocumentSection /> */}
    </div>
  );
}

// const ApplicantDocumentSection = () => {
//   const {
//     register,
//     formState: { errors },
//   } = useFormContext<FullRegistrationFormType>();

//   return (
//     <div>
//       <h3 className="text-[#344054] font-medium py-2">Applicant Document</h3>

//       <div className="flex gap-6">
//         <CustomDropdown
//           label="Document Type"
//           placeholder="Select document type"
//           name={"user_documentType"}
//           category={businessDetails.DOCUMENT_TYPE}
//           error={errors.user_documentType?.message}
//         />

//         <InputWithLabel
//           label="Document Number"
//           error={errors.user_documentNumber?.message}
//           {...register("user_documentNumber")}
//         />

//         <CustomDropdown
//           label="Issuance Country"
//           placeholder="Select issuance country"
//           name={`user_documentIssuanceCountry`}
//           category={businessDetails.COUNTRY_NAME}
//           error={errors.user_documentIssuanceCountry?.message}
//         />
//       </div>
//     </div>
//   );
// };
